import { PCXKeyValue } from '../domain/PCXKeyValue';

export class InsuranceConnectedCase {
    ItemId: string;
    InsuranceCaseId: string;
    InsuranceClaimNumber: string;
    LastRepairCaseConnectionCallStatus: string;
    LastRepairCaseSearchTerm: string | null;
    ConnectedCaseInfos: ConnectedWithInsuranceCase[];
}
export class ConnectedWithInsuranceCase {
    CaseId: string;
    InsuranceClaimNumber: string;
    CaseStatus: PCXKeyValue;
    ConnectedCaseType: string;
    ZipCodeOfIssuer: string;
    InspectorUserName: string;
    InspectorUserId: string;
    OrderDate: Date;
}
